<template>
  <v-list-item link @click.native="saveData" :disabled="disabled" :title="alt">
    <v-list-item-title>{{ title }}</v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "PersistDataButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    storageKey: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    alt: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    /**************
     *  METHODS   *
     **************/
    const saveData = () => {
      if (props.disabled) {
        return;
      }

      localStorage.setItem(props.storageKey, props.data);

      emit("dataPersisted");
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      saveData,
    };
  },
};
</script>
